import type { ModulesSlice, ModulesState, ViewerSliceCreator } from "./types";

export const modulesInitialState: ModulesState = {
  modules: [],
  assetsBaseUrl: "",
  moduleSearchTerm: "",
  moduleSelectedCategory: "all",
  moduleSelectedServoSeries: "all",
  pendingPlacementModule: null,
};

export const createModulesSlice: ViewerSliceCreator<ModulesSlice> = (set) => ({
  ...modulesInitialState,

  setModuleList: (msg) =>
    set((state) => {
      state.modules = msg.modules;
      state.assetsBaseUrl = msg.assets_base_url;
    }),

  setModuleSearchTerm: (term) =>
    set((state) => {
      state.moduleSearchTerm = term;
    }),

  setModuleSelectedCategory: (category) =>
    set((state) => {
      state.moduleSelectedCategory = category;
    }),

  setModuleSelectedServoSeries: (servoSeries) =>
    set((state) => {
      state.moduleSelectedServoSeries = servoSeries;
    }),

  setPendingPlacementModule: (module) =>
    set((state) => {
      state.pendingPlacementModule = module;
    }),
});
